<div class="error-content-container">
  <dxo-icon icon="warning" color="yellow" [fontSize]="44"></dxo-icon>
  <h1 class="bold heading-md">Oops! Something went wrong</h1>
  <h3 class="heading-sm">Your content is not currently loading</h3>
  <hr />
  <p class="info">
    Return to the previous page, or call <a href="tel:{{ contactPhone }}">{{ contactPhone }}</a> if you have questions.
  </p>
  <dxo-button [primary]="true" text="Return to previous screen" (handleClick)="navigateToPrevScreen()"></dxo-button>
</div>
